// extracted by mini-css-extract-plugin
module.exports = {"PageWrapper":"NotFound_PageWrapper__2Oiwv","Column":"NotFound_Column__255IE","ErrorIcon":"NotFound_ErrorIcon__5iVyB","BackButton":"NotFound_BackButton__2l3W5"};